import { render } from "./VideoAdvList.vue?vue&type=template&id=53298099&scoped=true"
import script from "./VideoAdvList.vue?vue&type=script&lang=js"
export * from "./VideoAdvList.vue?vue&type=script&lang=js"

import "./VideoAdvList.vue?vue&type=style&index=0&id=53298099&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53298099"]])

export default __exports__